import { render, staticRenderFns } from "./GoodInfo.vue?vue&type=template&id=9d46d3d0&scoped=true&"
import script from "./GoodInfo.vue?vue&type=script&lang=js&"
export * from "./GoodInfo.vue?vue&type=script&lang=js&"
import style0 from "./GoodInfo.vue?vue&type=style&index=0&id=9d46d3d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d46d3d0",
  null
  
)

export default component.exports